import { RootState } from 'reducers/rootReducer';
import { useSelector } from 'react-redux';

const useFormDefinition = (taskId: string) => {
    return useSelector((state: RootState) => state.taskForms[taskId]);
};
export default useFormDefinition;
